const defaultBranding = {
    // type of product - eg, "forms"
    ProductType: "games",
    // menu text to select product search tab - eg, "Forms Search"
    SearchLabel: "Games Search",
    // meta keyword specified in manifest (might not be the same as product type) - eg, "forms"
    MetaSearchKeyword: "games",
    // example searches on first run - eg, "Taxes, Immigration, US"
    SearchExample: "Pong",
    // eg, "Search form titles or tags"
    AutocompletePlaceholder: "Search games",
    // eg, "Search our database for forms by typing in a form query in the search box above."
    IntroLI1: "Get started by searching for your favorite games using the search box.",
    // eg, "You can also browse our forms database by 'tag' located on the left side menu of the page."
    IntroLI2: "",
    FirstRunSettings: false,
    PlaceholderImg: "/assets/images/placeholder.png",
}

const windowBranding = window.branding || {};

const PRODUCT_SEARCH_PROVIDERS = {
    default: {
        name: windowBranding.SearchEngineName,
        id: "default",
        isDefault:true,
        url: "/api/search?pageNo=0&perPage=10&q={{QUERY}}",
    },
}

const altSearchProvidersUrls = function(query) {
    const altProviders = Object.entries(PRODUCT_SEARCH_PROVIDERS).filter(([key, value]) =>  !value.isDefault);
    return altProviders.map(([key, value]) => {
        return {
            name: value.name,
            url: value.url.replace("{{QUERY}}", query),
        }
    });
}

const DEFAULT_PRODUCT_SEARCH_PROVIDER = PRODUCT_SEARCH_PROVIDERS["default"].id;

function getBranding(){
    return {
        ...defaultBranding,
        ...windowBranding,
    }
}

export {
    getBranding,
    PRODUCT_SEARCH_PROVIDERS,
    altSearchProvidersUrls,
    DEFAULT_PRODUCT_SEARCH_PROVIDER,
}



// WEBPACK FOOTER //
// ./src/branding.js